<!--
/*
 * @Author: your name
 * @Date: 2021-07-06 18:08:34
 * @LastEditTime: 2021-07-06 19:45:24
 * @LastEditors: lyy
 * @Description: In User Settings Edit
 * @FilePath: \maine:\git\xadc\src\components\NoData.vue
 * @Description: 列表 - 无数据
 */
 -->
<template>
  <div class="empty">
    <van-image
      class="empty-icon"
      :src="require('@/assets/img/common/wujieguo.png')"
    />
    <div class="empty-text">{{ text }}</div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    // 无结果的提示语
    msg: {
      type: String,
      default: '暂无结果，请重新搜索'
    }
  },
  data() {
    return {
      text: '' // 无结果的提示语
    }
  },
  watch: {
    msg: {
      handler(newValue) {
        this.text = newValue
      },
      deep: true,
      immediate: true // 第一次赋值也要触发监听
    }
  },
  computed: {},
  methods: {},
  created() {},
  mounted() {}
}
</script>
<style lang="scss" scoped>
.empty {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding-top: 100px;
  .empty-icon {
    width: 186px;
    height: 131px;
  }
  .empty-text {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #999999;
    padding-top: 10px;
  }
}
</style>
